// Keeps an unattended auto-check login alive, and sends the next sign-in
// back to Check if the token does die.

export const CHECK_PAGE_PATH = '/evaluate/check';
const POST_LOGIN_PATH_KEY = 'postLoginPath';
const RENEW_WITHIN_MS = 6 * 60 * 60 * 1000;

let expiryRedirectStarted = false;

export function autoCheckIsOn() {
  try {
    return localStorage.getItem('autoCheckEnabled') === 'true';
  } catch {
    return false;
  }
}

export function rememberCheckAfterLogin() {
  try {
    if (autoCheckIsOn()) localStorage.setItem(POST_LOGIN_PATH_KEY, CHECK_PAGE_PATH);
  } catch {}
}

export function consumePostLoginPath() {
  expiryRedirectStarted = false;
  try {
    const saved = localStorage.getItem(POST_LOGIN_PATH_KEY);
    localStorage.removeItem(POST_LOGIN_PATH_KEY);
    if (typeof saved === 'string' && saved.startsWith('/')) return saved;
  } catch {}
  return '/dashboard';
}

export function tokenExpiryMs(token) {
  try {
    const part = String(token || '').split('.')[1];
    if (!part) return 0;
    const padded = part.replace(/-/g, '+').replace(/_/g, '/');
    const json = JSON.parse(atob(padded));
    const exp = Number(json && json.exp);
    return Number.isFinite(exp) ? exp * 1000 : 0;
  } catch {
    return 0;
  }
}

export function tokenNeedsRenewal(token) {
  const exp = tokenExpiryMs(token);
  if (!exp) return true;
  return exp - Date.now() <= RENEW_WITHIN_MS;
}

export function tokenIsExpired(token) {
  const exp = tokenExpiryMs(token);
  return !exp || exp <= Date.now();
}

// Issue a fresh token from the one still accepted by the server.
export async function refreshAuthToken() {
  const token = localStorage.getItem('authToken');
  if (!token) return false;
  try {
    const res = await fetch(`${window.API_BASE_URL}/auth/refresh`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` }
    });
    if (!res.ok) return false;
    const data = await res.json().catch(() => ({}));
    if (!data || !data.token) return false;
    localStorage.setItem('authToken', data.token);
    if (data.user) {
      try {
        const prev = JSON.parse(localStorage.getItem('currentUser') || '{}');
        localStorage.setItem('currentUser', JSON.stringify({ ...prev, ...data.user }));
      } catch {}
    }
    expiryRedirectStarted = false;
    return true;
  } catch {
    return false;
  }
}

// Auto-check lost its login. Open the login screen once; the next
// successful sign-in returns to Check.
export function requestLoginAfterExpiry() {
  if (expiryRedirectStarted || !autoCheckIsOn()) return;
  expiryRedirectStarted = true;
  rememberCheckAfterLogin();
  window.dispatchEvent(new Event('fg-session-expired'));
}
